import { reactive } from 'vue';

// Guard ↔ App.vue arasında paylaşılan hafif reaktif UI durumu.
// navLoading: oturum içi sayfa geçişinde (AdminLayout zaten ekranda) route guard
//   (GetYetkiKontrol / refresh / lisans) beklerken true — AdminLayout içeriğinin üstünde
//   ince bir ilerleme çubuğu olarak gösterilir, navbar/Sparqon kapanmaz.
// bootLoading: henüz gösterilecek bir kabuk yokken (ilk sayfa yüklemesi / girişten hemen
//   sonra) aynı bekleme — App.vue'da tam ekran gösterilir.
// destekMerkeziVar: AdminLayout'un mount'ta bir kez okuduğu "DestekMerkezi" lisansı - ayrı
//   rotalanan sayfalar (YeniCagri.vue, Cagrilarim.vue) AdminLayout'un kendi data'sına erişemediği
//   için buradan okur, CG3: aynı bilgi için ikinci bir GetAktifLisanslarim isteği atılmaz.
// menuTazeleGerekli / menuSonCekim: navbar yetki tazeleme (NB planı) — lisans/rol değişince
//   AdminLayout'un bir sonraki TTL/odak kontrolünde _GetNavbar()'ı yeniden çağırması gerektiğini
//   işaretler; menuSonCekim yalnız başarılı _GetNavbar() dönüşünde güncellenir.
// yardimliSayfalar / yardimListesiHata: SB/YR planı — AdminLayout mount'ta bir kez
//   GetYardimliSayfaListesi çeker (destekMerkeziVar ile aynı emsal); null = henüz gelmedi,
//   dizi = geldi, yardimListesiHata = true ise istek başarısız oldu (yardım butonu yine de
//   gösterilir, panel boş durum gösterir).
// sayfaBasligi: SayfaBasligi.vue'nun (sayfa tarafı) SayfaBasligiAlani.vue'ya (layout tarafı)
//   Teleport dışında geçtiği tek kanal — dinamik başlık, Aktif/Pasif, durum etiketi, geri
//   yedek hedefi. Sayfa unmount olunca SayfaBasligi.vue hepsini null'a döndürür.
// lisansUyari: LS4 - AdminLayout'un _AiLisansKontrol'de hesapladığı { Ad, Kod, KalanGun,
//   TemelMi } nesnesi (bitişe en az gün kalan, Basic/TemelMi öncelikli); null = uyarılacak
//   lisans yok. Layout sarmalayıcısındaki tam genişlik uyarı şeridi buradan okur.
export const uiState = reactive({
  navLoading: false,
  bootLoading: false,
  destekMerkeziVar: false,
  menuTazeleGerekli: false,
  menuSonCekim: 0,
  yardimliSayfalar: null,
  yardimListesiHata: false,
  lisansUyari: null,
  // KT3: temaSiniflariniUygula (tema.js) her çağrıda yazar - public zorlama yolu (router.js) da
  // buradan geçiyor. TinyMCE gibi yalnız mount'ta okuyan bileşenlerin :key ile yeniden kurulması
  // için tek doğru reaktif kaynak.
  koyuTema: false,
  // AB1: alanBoyutu.js boyutUygula yazar — normal | kucuk.
  alanBoyutu: "normal",
  sayfaBasligi: {
    baslik: null,
    pasif: null,
    durumMetni: null,
    geriYedek: null,
  },
});

export const MENU_TTL_MS = 60000;

// router afterEach (her gezinmede) ve AdminLayout (visibilitychange/focus'ta) aynı TTL
// kontrolünü ayrı ayrı yapar — mantığı tek yerde tutar. menuSonCekim=0 (hiç çekilmemiş)
// için de true döner, ama AdminLayout henüz mount olmadıysa bunu okuyan yok, zararsız.
export function menuTtlDoldu() {
  return Date.now() - uiState.menuSonCekim > MENU_TTL_MS;
}
